import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { NeverbounceConfigurationState } from '../reducers/neverbounce-configuration.reducer';
import * as selectors from '../selectors/neverbounce-configuration.selectors';

@Injectable()
export class NeverbounceConfigurationFacadeService extends FacadeService {
  constructor(public override store: Store<NeverbounceConfigurationState>) {
    super(store);
  }

  // OBSERVABLES

  nameNeverbounce$ = this.storeSelect(selectors.getNameNeverbounce);
  statusNeverbounce$ = this.storeSelect(selectors.getStatusNeverbounce);
  notificationEmailNeverbounce$ = this.storeSelect(selectors.getNotificationEmailNeverbounce);
  jobMaxSizeNeverbounce$ = this.storeSelect(selectors.getJobMaxSizeNeverbounce);
  resultTypesNeverbounce$ = this.storeSelect(selectors.getResultTypesNeverbounce);
  baseUrlNeverbounce$ = this.storeSelect(selectors.getBaseUrlNeverbounce);
  readTimeoutNeverbounce$ = this.storeSelect(selectors.getReadTimeoutNeverbounce);
  connectionTimeoutNeverbounce$ = this.storeSelect(selectors.getConnectionTimeoutNeverbounce);
  apiKeyNeverbounce$ = this.storeSelect(selectors.getApiKeyNeverbounce);
  showUpdateBtn$ = this.storeSelect(selectors.getShowUpdateBtn);
  disableNameValue$ = this.storeSelect(selectors.getDisableNameValue);
  rootConfigurationHelpTextStatus$ = this.storeSelect(selectors.getRootConfigurationHelpTextStatus);
  credentialsConfigurationHelpTextStatus$ = this.storeSelect(
    selectors.getCredentialsConfigurationHelpTextStatus,
  );
  endpointConfigurationHelpTextStatus$ = this.storeSelect(
    selectors.getEndpointConfigurationHelpTextStatus,
  );
  selectedNeverbounceDataFromGrid$ = this.storeSelect(selectors.getSelectedNeverbounceDataFromGrid);
  showCancelBtn$ = this.storeSelect(selectors.getShowCancelBtn);
  neverbounceDataAreValid$ = this.storeSelect(selectors.getNeverbounceDataAreValid);
  showNameErrorMsg$ = this.storeSelect(selectors.getShowNameErrorMsg);
  showBaseUrlErrorMsg$ = this.storeSelect(selectors.getShowBaseUrlErrorMsg);
  showApiKeyErrorMsg$ = this.storeSelect(selectors.getShowApiKeyErrorMsg);
  showJobMaxSizeErrorMsg$ = this.storeSelect(selectors.getShowJobMaxSizeErrorMsg);
  showJobMaxSizeErrorValueMsg$ = this.storeSelect(selectors.getShowJobMaxSizeErrorValueMsg);

  // OBSERVABLE'S VALUES

  get nameNeverbounce() {
    return this.storeSnapshot(this.nameNeverbounce$);
  }

  get statusNeverbounce() {
    return this.storeSnapshot(this.statusNeverbounce$);
  }

  get notificationEmailNeverbounce() {
    return this.storeSnapshot(this.notificationEmailNeverbounce$);
  }

  get jobMaxSizeNeverbounce() {
    return this.storeSnapshot(this.jobMaxSizeNeverbounce$);
  }

  get resultTypesNeverbounce() {
    return this.storeSnapshot(this.resultTypesNeverbounce$);
  }

  get baseUrlNeverbounce() {
    return this.storeSnapshot(this.baseUrlNeverbounce$);
  }

  get readTimeoutNeverbounce() {
    return this.storeSnapshot(this.readTimeoutNeverbounce$);
  }

  get connectionTimeoutNeverbounce() {
    return this.storeSnapshot(this.connectionTimeoutNeverbounce$);
  }

  get apiKeyNeverbounce() {
    return this.storeSnapshot(this.apiKeyNeverbounce$);
  }

  get showUpdateBtn() {
    return this.storeSnapshot(this.showUpdateBtn$);
  }

  get selectedNeverbounceDataFromGrid() {
    return this.storeSnapshot(this.selectedNeverbounceDataFromGrid$);
  }

  get neverbounceDataAreValid() {
    return this.storeSnapshot(this.neverbounceDataAreValid$);
  }

  getNeverbounceBody() {
    const neverbounceBody = {
      integrationCode: this.nameNeverbounce,
      deleted: this.statusNeverbounce,
      integrationConfig: {
        integrationSystem: 'NEVERBOUNCE',
        integrationDisplayName: this.nameNeverbounce,
        notificationEmail: this.notificationEmailNeverbounce,
        jobMaxSize: this.jobMaxSizeNeverbounce,
        validResultTypes: this.resultTypesNeverbounce,
      },
      endpointConfiguration: {
        code: this.nameNeverbounce,
        endpointConfig: {
          type: 'HTTP',
          method: 'POST',
          baseURL: this.baseUrlNeverbounce,
          dateFormat: null,
          headers: {
            'Content-Type': 'application/json',
          },
          skipSSL: false,
          pathParams: {},
          queryParams: {},
          readTimeOut: this.readTimeoutNeverbounce,
          connectionTimeOut: this.connectionTimeoutNeverbounce,
          requestContentType: 'application/json',
          responseContentType: 'application/json',
        },
        credentialConfig: {
          key: this.apiKeyNeverbounce,
          type: 'API_KEY',
          bypassEncryption: false,
        },
      },
    };

    return neverbounceBody;
  }
}
